import { Button, Header, LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'

import '../SwitchToMobile.css'
import { forceRedirect } from '@/methods/forceRedirect'
import { DividerWithText } from '@/components/DividerWithText/DividerWithText'
import { Illustration } from '@/components/Illustration/Illustration'
import { cx } from '@/utils/cx'

interface ScanQRProps {
  nextStep: () => void
  stayUrl?: string
}

export const HowToContinue = observer(({ nextStep, stayUrl }: ScanQRProps) => {
  const store = useContext(StoreContext)
  const { switchToMobile: trans } = store.TranslationsState.translationsNew

  const [btnContinueLoading, setBtnContinueLoading] = useState(false)
  const [btnSwitchLoading, setBtnSwitchLoading] = useState(false)

  const continueHandler = () => {
    if (!btnContinueLoading && stayUrl?.length) {
      setBtnContinueLoading(true)
      forceRedirect(stayUrl)
    }
  }

  const nextStepHandler = () => {
    setBtnSwitchLoading(true)
    nextStep()
  }

  return stayUrl ? (
    <>
      <Header>{trans.howToContinue?.header}</Header>
      <div className="layout__margined m-0-0-15" />
      <Illustration type="switch-to-mobile" />

      <div className="layout__vertically-centered-container">
        <p className="generic__paragraph-centered m-0">{trans.howToContinue?.continueOnDevide}</p>
        <div className="layout__margined m-0-0-30" />
        <Button
          onClick={continueHandler}
          disabled={btnSwitchLoading}
          tabIndex={0}
          className="how-to-continue__btn how-to-continue__btn--continue"
        >
          {btnContinueLoading && <LoadingSpinner inButton />}
          <span
            className={cx(
              'generic__button-text',
              btnContinueLoading && 'generic__button-text--loading'
            )}
            data-testId="proceed"
          >
            {trans.howToContinue?.continue}
          </span>
        </Button>
      </div>

      <DividerWithText text={`${trans.howToContinue?.or ?? 'or'}`} margin="30px 0" width="100%" />

      <div className="layout__vertically-centered-container">
        <p className="generic__paragraph-centered m-0">{trans.howToContinue?.continueOnMobile}</p>
        <div className="layout__margined m-0-0-30" />
        <Button
          onClick={nextStepHandler}
          className="button--secondary how-to-continue__btn how-to-continue__btn--switch"
          disabled={btnContinueLoading}
          tabIndex={0}
        >
          {btnSwitchLoading && <LoadingSpinner inButton />}
          <span
            className={cx(
              'generic__button-text',
              btnSwitchLoading && 'generic__button-text--loading'
            )}
            data-testId="proceed"
          >
            {trans.howToContinue?.switchToMobile}
          </span>
        </Button>
      </div>
    </>
  ) : (
    <LoadingSpinner />
  )
})
